function translateProviderConfig($translateProvider) {
  $translateProvider.useStaticFilesLoader({
    prefix: './assets/i18n/',
    suffix: '.json',
  });

  // load English ('en') table on startup
  $translateProvider.preferredLanguage('en');

  // Enable escaping of HTML
  $translateProvider.useSanitizeValueStrategy('escape');

  // remember language
  $translateProvider.useCookieStorage();
}

translateProviderConfig.$inject = ['$translateProvider'];

export default translateProviderConfig;
